import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth';
import { API_BASE_URL } from '../config';

export default function AnalyticsPage() {
  const { id } = useParams<{ id: string }>();
  const { jwt } = useAuth();
  const [analytics, setAnalytics] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchAnalytics() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/${id}/analytics`, {
          headers: { Authorization: `Bearer ${jwt}` },
        });
        if (!res.ok) {
          throw new Error('Failed to fetch analytics');
        }
        const data = await res.json();
        setAnalytics(data);
      } catch (e) {
        if (e instanceof Error) {
          setError(e.message);
        } else {
          setError('Unknown error');
        }
      } finally {
        setLoading(false);
      }
    }
    fetchAnalytics();
  }, [id, jwt]);

  return (
    <div className="max-w-xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Analytics: {id}</h1>
      {loading && <p className="text-gray-500">Loading...</p>}
      {error && <p className="text-red-600">{error}</p>}
      {analytics && (
        <div className="bg-gray-100 rounded p-4">
          <div className="mb-2">
            Scan Count: <span className="font-bold">{analytics.scanCount}</span>
          </div>
          <div className="mb-2">Scan Timestamps:</div>
          <ul className="list-disc list-inside mb-2 text-xs">
            {analytics.scanTimestamps?.map((ts: string, i: number) => (
              <li key={i}>{ts}</li>
            ))}
          </ul>
          <details>
            <summary className="cursor-pointer text-blue-600">Raw Data</summary>
            <pre className="text-xs mt-2 overflow-x-auto">
              {JSON.stringify(analytics, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
}
